import request from '@/util/request'

// 赛事组别列表（不分页）
export const getCompetitionGroupList = (data) => {
  return request({
    url: `/api/register/competition/group/list`,
    method: 'GET',
    data
  })
}
